'use client'

import { useTranslate } from '@repo/shared/hooks'
import { useRouter } from '@repo/shared/i18n/navigation'
import { Button, Col, Icon, Separator } from '@repo/ui/components'
import type { ReactNode } from 'react'

export type QuickTradeCTAProps = {
  children: ReactNode
}

export const QuickTradeCTA = ({
  origin,
}: {
  origin: 'layout' | 'container'
}) => {
  const { t } = useTranslate()
  const { back } = useRouter()

  return (
    <Col
      className={`max-w-[688px] w-full mx-auto ${origin === 'layout' ? 'sticky top-0 bg-neutral-surface-light' : ''}`}
    >
      <div className={origin !== 'layout' ? '' : 'px-xs py-xs'}>
        <Button
          type='button'
          color='neutral'
          variant='transparent'
          size={origin !== 'layout' ? 'lg' : 'md'}
          startIcon={
            origin === 'layout' && <Icon name='ArrowRightLine' size='md' />
          }
          onClick={origin === 'layout' ? back : undefined}
        >
          {t('quickTrade_title')}
        </Button>
      </div>
      {origin === 'layout' && <Separator />}
    </Col>
  )
}
